import { useRef, useState } from "react";
import { cn } from "../../../../utils/cn.ts";
import { focusStylesRingOffset } from "../../../../utils/focus-styles.ts";
import LoadingResponsiveImage from "../../../../components/responsive-image/loading-responsive-image.tsx";
import { PhotosModal } from "./photos-modal.tsx";
import { usePropertyDetailsContext } from "../../../contexts/property-details-context.tsx";

export const Photos = () => {
  const { images = [] } = usePropertyDetailsContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const buttonRefs = useRef<(HTMLButtonElement | null)[]>([]);

  if (images.length === 0) return null;

  const openModal = (index: number) => {
    setSelectedIndex(index);
    setModalOpen(true);
  };

  const rows = [];
  let imageIndex = 0;
  let rowIndex = 0;

  while (imageIndex < images.length) {
    const isWideRow = rowIndex % 2 === 0;
    const count = isWideRow ? 2 : 3;
    const rowImages = images.slice(imageIndex, imageIndex + count);
    const imageDesktopWidth = Math.round(100 / rowImages.length).toString() + "vw";

    rows.push(
      <div key={rowIndex} className="flex flex-col md:flex-row gap-2.5 md:gap-5 lg:gap-6.5 w-full">
        {rowImages.map((image, j) => {
          const globalIdx = imageIndex + j;
          return (
            <button
              key={globalIdx}
              ref={(el) => {
                buttonRefs.current[globalIdx] = el;
              }}
              type="button"
              aria-label={`View image ${(globalIdx + 1).toString()} of ${images.length.toString()}`}
              onClick={() => openModal(globalIdx)}
              className={cn(
                `aspect-[360/240] flex-1 min-w-0 relative overflow-hidden cursor-pointer group`,
                focusStylesRingOffset,
              )}
            >
              <LoadingResponsiveImage
                image={image}
                desktopWidth={imageDesktopWidth}
                mobileWidth={"100vw"}
                className="w-full h-full transition-transform duration-300 group-hover:scale-105"
              />
            </button>
          );
        })}
      </div>,
    );

    imageIndex += rowImages.length;
    rowIndex++;
  }

  return (
    <>
      <div className="flex flex-col  gap-2.5 md:gap-5 lg:gap-6.5">{rows}</div>
      <PhotosModal
        initialIndex={selectedIndex}
        isOpen={modalOpen}
        onOpenChange={setModalOpen}
        focusOnClose={() => buttonRefs.current[selectedIndex] ?? null}
      />
    </>
  );
};
